import { useEffect } from "react";

export default function useSetBrandOnLoad(change, brand) {
  useEffect(() => {
    change({
      target: {
        name: "brand",
        value: brand
      }
    });
  }, [brand]);
}
